import { TimePicker } from "antd";

export default TimePicker;
